import React from "react";
import {API_ENDPOINT as baseUrl} from "../../../../config";
import {getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import Button from "../../../../components/Button";
import {requestScanBarcode} from "../../../../actions/InventoryApiActions";
import {updatePackages} from "../../../../actions/WarehousePackageActions";
import {useDispatch} from "react-redux";
import {graphql} from "react-apollo";
import {compose} from "redux";
import {connect} from "react-redux";
import {showContextualMenu} from "../../../../actions/ViewActions";
import ContextMenuTrigger from "../../../../components/ContextMenuTrigger";
import {CANCEL_PACKING, MARK_PACKED} from "../../../../queries/warehouseJobs";
import styles from "./PackageActions.module.scss";
import InvoiceStorage from "../../../../lib/InvoiceStorage";


// During packing, the user can:
// - download labels for each job;
// - scan, rescan and mark as packed for individual packages.
const PackingActions = (props) => {
  const { jobId } = props;

  if (jobId) {
    return <ActionsForSingleJob {...props} />;
  } else {
    return <ActionsForSinglePackage {...props} />;
  }
}

// User can download and print labels for later scanning.
function ActionsForSingleJob(props) {
  const { warehouseId, jobId, packages } = props;

  const dispatch = useDispatch();

  const handleDownloadLabels = () => {
    // Send query to server
    downloadLabels(warehouseId, jobId);
  }

  const handleJobRevert = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, packages.map((p) => getPackageUID(p)), (p) => p.set("state", PACKAGE_STATES.DUE_TO_PROCESS)));
    // Send mutation to server
    return props.cancelPacking(warehouseId, jobId, packages.map((p) => p.get("packageId")));
  }

  const onContextClick = (x, y) => {
    let items = [
      {label: "Download Labels", lambda: handleDownloadLabels },
      {label: "Cancel packing", lambda: handleJobRevert },
    ];

    props.showContextualMenu(items, x, y);
  }

  return (
    <div className={styles.headerActions}>
      <Button key={jobId}
        active={props.active}
        onClick={handleDownloadLabels}
        label="Download Labels"
        primary={false}
        icon={<span className={"withPdfIcon"} />}
      />
      <ContextMenuTrigger active={props.active} onClick={onContextClick}/>
    </div>
  );
}

// User can scan, rescan and mark package as picked, depending on "serial" prop
// state of the package's skus.
function ActionsForSinglePackage(props) {
  const { warehouseId, pack } = props;

  const dispatch = useDispatch();

  if (!pack) {
    return null;
  }

  const notScannable = pack.get("skus").every((s) => s.get("serial") === "not_applicable");
  const scanned = pack.get("skus").find((s) => s.get("serial") === "provided");

  const handleDownloadLabel = () => {
    // Send query to server
    downloadLabels(warehouseId, pack.get("jobId"), [pack.get("packageId")]);
  }
  const handleMarkPacked = () => {
    // Update packages in the reducer
    dispatch(updatePackages(warehouseId, [getPackageUID(pack)], (p) => p.set("state", PACKAGE_STATES.PICKUP_READY)));
    // Send mutation to server
    props.markPacked(warehouseId, pack.get("jobId"), [pack.get("packageId")]);
  }
  const handleScanBarcode = () => {
    console.log("handle scan ", getPackageUID(pack), warehouseId)
    dispatch(requestScanBarcode(warehouseId, getPackageUID(pack)));
  };

  let buttons = null;
  const contextMenuItems = [];

  if (notScannable) {
    // Just mark as packed
    buttons = <Button active={props.active} onClick={handleMarkPacked} label="Mark as Packed" />;
    contextMenuItems.push({label: "Mark as Packed", lambda: handleMarkPacked });
  } else if (scanned) {
    // User can either rescan or mark as packed
    buttons = (
      <>
        <div onClick={props.active ? handleScanBarcode : undefined} className={styles.scannedIcon} />
        <Button active={props.active} onClick={handleMarkPacked} label="Mark as Packed" />
      </>
    );
    contextMenuItems.push({label: "Scan", lambda: handleScanBarcode });
    contextMenuItems.push({label: "Mark as Packed", lambda: handleMarkPacked });
  } else {
    buttons = (
      // Needs to be scanned
      <>
        <span className={styles.pdfIcon}
          onClick={props.active ? handleDownloadLabel : undefined}
        />
        <Button
          active={props.active}
          onClick={handleScanBarcode}
          label="Scan"
          icon={<span className={"withBarcodeIcon"} />}
        />
      </>
    );
    contextMenuItems.push({label: "Scan", lambda: handleScanBarcode });
    contextMenuItems.push({label: "Download Label", lambda: handleDownloadLabel });
  }

  const onContextClick = (x, y) => {
    props.showContextualMenu(contextMenuItems, x, y);
  }

  return (
    <div className={styles.headerActions}>
      { buttons }
      <ContextMenuTrigger active={props.active} onClick={onContextClick}/>
    </div>
  );
}

// Download the labels for a job, with optional package ids.
function downloadLabels(warehouseId, jobId, packagesIds = null) {
  console.log("DL LABELS", warehouseId, jobId, packagesIds)
  // Todo package ids for individual labels
  let url = `${baseUrl}/shippinglabels/warehouses/${warehouseId}/${jobId}`;
  if (packagesIds) {
    url += "?ids=" + packagesIds.join(",");
  }

  InvoiceStorage.download(url, "_blank");
}

const withQuery = compose(
  graphql(MARK_PACKED, {
    props: ({ mutate }) => ({
      markPacked: (warehouseId, jobId, packageIds) => mutate({
        variables: { data: { warehouseId, jobId, packageIds } }
      })
    })
  }),
  graphql(CANCEL_PACKING, {
    props: ({ mutate }) => ({
      cancelPacking: (warehouseId, jobId, packageIds) => mutate({
        variables: { data: { warehouseId, jobId, packageIds } }
      })
    })
  }),
);

export default connect(null, {showContextualMenu})(withQuery(PackingActions));